<template>
  <v-form v-model="valid" ref="mainForm">
    <data-iterator
      :list="sas.diplomes"
      add-new-text="Ajouter un diplôme"
      :live="{ endpoint: 'sas-diplomes', sasId: sas.id }"
      :icon="$getIcon('school')"
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:show-mode="{ item }">
        <h3 v-if="estTypeEtablissement(item.typeEtablissement, 1)">
          {{ item.universite && !estAutreUniversite(item.universite) ? getCatalogueValueById(4906, item.universite).text : item.autreUniversite }}
        </h3>
        <h3 v-if="estTypeEtablissement(item.typeEtablissement, 2)">
          {{ getCatalogueValueById(4902, item.typeEtablissement).text }}
        </h3>
        <h3 v-if="estTypeEtablissement(item.typeEtablissement, 3)">
          {{ getCatalogueValueById(4902, item.typeEtablissement).text }}
        </h3>
        <p class="my-0">
          {{ item.diplome && !estAutreDiplome(item.diplome) ? getCatalogueValueById(9223, item.diplome).text : item.autreDiplome }}
        </p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <opq-catalogue code="pays-diplome" v-model="item.paysObtention" :live="liveSasDiplomes(2702, item)" order-by="text"> </opq-catalogue>
        <opq-catalogue
          :opq-if="paysEstUSouCA(item.paysObtention)"
          code="province-diplome"
          v-model="item.provinceObtention"
          :live="liveSasDiplomes(2703, item)"
          :parent="item.paysObtention"
          order-by="text"
        >
        </opq-catalogue>
        <opq-catalogue code="type-etablissement-diplôme" v-model="item.typeEtablissement" :live="liveSasDiplomes(2711, item)"> </opq-catalogue>
        <opq-catalogue
          :opq-if="estTypeEtablissement(item.typeEtablissement, 1)"
          code="universite"
          v-model="item.universite"
          :live="liveSasDiplomes(2704, item)"
        >
        </opq-catalogue>
        <opq-text-field
          :opq-if="estAutreUniversite(item.universite)"
          code="autre-universite"
          v-model="item.autreUniversite"
          :live="liveSasDiplomes(2705, item)"
        ></opq-text-field>
        <opq-file
          :opq-if="estTypeEtablissement(item.typeEtablissement, 2)"
          code="etablissement-prive"
          :file="item.etablissementPrive"
          :live="liveSasDiplomes(2718, item)"
        ></opq-file>
        <opq-file
          :opq-if="estTypeEtablissement(item.typeEtablissement, 3)"
          code="formateur-independant"
          :file="item.formateurIndependant"
          :live="liveSasDiplomes(2719, item)"
        ></opq-file>

        <opq-catalogue code="diplome" v-model="item.diplome" :live="liveSasDiplomes(2706, item)"> </opq-catalogue>
        <opq-text-field
          :opq-if="estAutreDiplome(item.diplome)"
          code="autre-diplome"
          v-model="item.autreDiplome"
          :live="liveSasDiplomes(2707, item)"
        ></opq-text-field>
        <opq-text-field code="duree-programme" v-model="item.dureeDuProgramme" :live="liveSasDiplomes(2715, item)" isNumber></opq-text-field>
        <opq-catalogue code="diplome-obtenu" v-model="item.diplomeObtenu" :live="liveSasDiplomes(2713, item)"> </opq-catalogue>
        <opq-date-picker
          :opq-if="estOui(item.diplomeObtenu)"
          code="date-diplome"
          hide-day
          v-model="item.dateObtention"
          :live="liveSasDiplomes(2714, item)"
        ></opq-date-picker>
        <opq-alert v-show="estOui(item.diplomeObtenu)" code="fichiers-etape-3"></opq-alert>
        <opq-file-multiple :opq-if="estOui(item.diplomeObtenu)" code="copie-diplome" :files="item.copieDuDiplome" :live="liveSasDiplomes(2712, item)">
        </opq-file-multiple>
        <opq-file-multiple code="releve-notes" :files="item.relevesDeNotes" :live="liveSasDiplomes(2717, item)"> </opq-file-multiple>
      </template>
    </data-iterator>
  </v-form>
</template>

<script>
import FormHybrid from "@/mixins/FormHybrid"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [FormHybrid, CataloguesHelper],
  props: {
    sas: { type: Object }
  },
  methods: {
    liveSasDiplomes(cle, item) {
      return { endpoint: "sas-diplomes", cle: cle, fileId: item.id }
    },
    estAutreUniversite(universite) {
      return this.getCatalogueCodeById(4906, universite) == "autre"
    },
    estAutreDiplome(diplome) {
      return diplome == "JnPHZbChu9Z2CNDTrWQlPQR1EpL1R1EpL1"
    },
    estTypeEtablissement(type, code) {
      return this.getCatalogueCodeById(4902, type) == code
    }
  }
}
</script>

<style>
</style>